module.exports = __webpack_public_path__ + "img/12.913402c8.png";